import { Box, Grid, Typography } from '@mui/material';
import { Button } from '@components/button/Button';
import { LoginSource } from '@pages/Login/constants';

export const RegistrationFormFooter = ({
  loginSource,
  onBackToSignIn,
  onSelectDifferentRole,
}: {
  loginSource: LoginSource;
  onBackToSignIn: () => void;
  onSelectDifferentRole?: () => void;
}) => (
  <Grid
    size={{ xs: 12 }}
    sx={{
      textAlign: onSelectDifferentRole ? 'center' : 'left',
      mt: 1,
    }}
  >
    {onSelectDifferentRole ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0 }}>
        <Button color='secondary' variant='text' disableRipple onClick={onSelectDifferentRole}>
          Select a different role
        </Button>
        <Typography aria-hidden='true' sx={{ color: 'text.subdued', mx: 0.5 }}>
          |
        </Typography>
        <Button color='secondary' variant='text' disableRipple onClick={onBackToSignIn}>
          Back to sign in
        </Button>
      </Box>
    ) : (
      <Button variant='text' disableRipple onClick={onBackToSignIn}>
        {loginSource === LoginSource.QUOTE_SETUP_PRESET ? 'Already registered? Sign in' : 'Back to sign in'}
      </Button>
    )}
  </Grid>
);
